"use client";

import React from "react";
import { IntlProvider, ReactIntlErrorCode } from "react-intl";
import { SiteSettings } from "src/lib/cms/cms";
import { EmilProvider } from "src/lib/emil/context";
import {
	PortalTypeContext,
	PreviewContext,
	SiteSettingsContext,
	TargetGroupContext,
	ProductContext,
	Product,
} from "src/lib/hooks";
import { QueryClientProvider } from "./QueryClientProvider";
import type { PortalType, TargetGroup } from "src/lib/ssr/utils";

type SharedContextProps = {
	siteSettings: SiteSettings;
	children: React.ReactNode;
	targetGroup?: TargetGroup;
	portalType?: PortalType;
	isPreview?: boolean;
	product?: Product;
};

export const SharedContext: React.FC<SharedContextProps> = ({
	children,
	siteSettings,
	targetGroup,
	product,
	portalType,
	isPreview,
}) => {
	return (
		<EmilProvider>
			<IntlProvider
				locale={siteSettings.locale}
				messages={siteSettings.translations}
				/**
				 * Reduce react-intl's "missing translation" error to a warning
				 */

				onError={(err) => {
					if (err.code === ReactIntlErrorCode.MISSING_TRANSLATION) {
						// eslint-disable-next-line no-console
						console.warn(err.message);

						return;
					}
					throw err;
				}}
			>
				<SiteSettingsContext.Provider value={siteSettings}>
					<PortalTypeContext.Provider value={portalType ?? null}>
						<TargetGroupContext.Provider
							value={targetGroup ?? null}
						>
							<ProductContext.Provider value={product ?? null}>
								<PreviewContext.Provider
									value={isPreview ?? false}
								>
									<QueryClientProvider>
										{children}
									</QueryClientProvider>
								</PreviewContext.Provider>
							</ProductContext.Provider>
						</TargetGroupContext.Provider>
					</PortalTypeContext.Provider>
				</SiteSettingsContext.Provider>
			</IntlProvider>
		</EmilProvider>
	);
};

// 🔬 TBD: Please evaluate
